import uuid from 'uuid-random';

import {
    POPUP_IDS as POPUP_IDS_ORIGINAL,
    POPUP_TEMPLATE_IDS as POPUP_TEMPLATE_IDS_ORIGINAL
} from 'js/components/common/PopupManager/constants';

export * from 'js/components/common/PopupManager/constants';

export const POPUP_IDS = {
    ...POPUP_IDS_ORIGINAL,
    SELF_EXCLUSION_POPUP: uuid()
};

// mapping of popup ids to template ids from pushes (e.g. 31133, 31026)
export const POPUP_TEMPLATE_IDS = {
    ...POPUP_TEMPLATE_IDS_ORIGINAL,
    [POPUP_IDS.SELF_EXCLUSION_POPUP]: 'rg_selfexclude_player_logged_off'
};
